module.exports = __webpack_public_path__ + "img/icon-message.ff410ca6.svg";